module.exports = __webpack_public_path__ + "img/totalizador-inconforme.501b2061.svg";